/**
 * Created by why on 2019/8/17.
 */
import axios from '@/libs/api.request'
export const getTransactionByCondition = (data) => {
  return axios.request({
    url: '/transactionRecord/getByCondition',
    params: data,
    method: 'get'
  })
}

export const getTransactionByCode = (data) => {
  return axios.request({
    url: '/transactionRecord/getByCode',
    params: data,
    method: 'get'
  })
}

export const editTransaction = (data) => {
  return axios.request({
    url: '/transactionRecord/edit',
    params: data,
    method: 'post'
  })
}

export const delTransactionByIds = (ids) => {
  return axios.request({
    url: `/transactionRecord/delByIds/${ids}`,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/transaction-record-manage.js